import * as React from 'react';

import Campo from './Campo';

export interface Props {
    tipo: 'rut' | 'pasaporte';
    valor: string;
}

const RutPasaporte: React.FunctionComponent<Props> = props => {
    const { tipo, valor } = props;

    const etiqueta = tipo === 'rut' ? 'RUT' : 'Pasaporte';
    return <Campo etiqueta={etiqueta} valor={valor} />;
};

export default RutPasaporte;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/paginas/InformacionGeneral/componentes/RutPasaporte.tsx